<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleArticoli > 0"
      item-key="_id"
      :headers="headers"
      :items="articoliSorted"
      :options.sync="options"
      :server-items-length="totaleArticoli"
      :loading="loading"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 15, 50, 100],
      }"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
      dense
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Articoli</v-toolbar-title>
          <!--    <v-divider class="mx-4" inset vertical></v-divider> -->
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="onNuovoArticolo"
            >Nuovo Articolo</v-btn
          >
          <v-dialog v-model="dialogDelete" max-width="550px">
            <v-card>
              <v-card-title class="text-h5"
                >Confermi cancellazione articoli selezionati ?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="deleteItemConfirm"
                  :disabled="disableButtonConfirmCancellation"
                  >SI</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="closeDelete"
                  :disabled="disableButtonConfirmCancellation"
                  >NO</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <dialog-errore :show="dialogErrore" title="Abilitazione eCommerce" />
          <v-dialog v-model="dialogECommerce" max-width="500px">
            <v-card>
              <v-card-title class="text-h5">Gestione eCommerce</v-card-title>
              <v-card-text
                >Confermi inversione abilitazione eCommerce per i prodotti
                selezionati ?</v-card-text
              >
              <!--             <v-card-title class="text-h5">Confermi abilitazione eCommerce per i prodotti selezionati ?</v-card-title> -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="eCommerceConfirm"
                  >SI</v-btn
                >
                <v-btn
                  color="blue darken-1"
                  text
                  @click="dialogECommerce = false"
                  >NO</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <filtri :usaTagliaColore="usaTagliaColore" @ricerca="onRicerca" />
      </template>
      <template v-slot:[`item.speciali`]="{ item }">
        <v-icon
          v-if="
            item.lotti && item.lotti.gestione && item.lotti.gestione.abilita
          "
          small
          :title="titleLotti(item)"
          :color="coloreLotti(item)"
          >mdi-clipboard-text-outline</v-icon
        >
        <v-icon
          v-if="item.lotti && !item.lotti.gestione && item.lotti.prodottoBase"
          small
          :title="titleLotti(item)"
          :color="coloreLotti(item)"
          >mdi-clipboard-text-outline</v-icon
        >
        <v-icon
          v-if="item.bom && item.bom.gestione && item.bom.gestione.abilita"
          small
          :title="titleBom(item)"
          :color="coloreBom(item)"
          >mdi-family-tree</v-icon
        >
        <v-icon
          v-if="item.eCommerce && item.eCommerce.abilita"
          small
          title="Abilitato per eCommerce"
          class="ml-2"
          @click="apriCommerce(item)"
          >{{
            allegatiEcommerce(item) ? "mdi-cart" : "mdi-cart-outline"
          }}</v-icon
        >
        <v-icon v-if="item.tipoBene === 'BUONOPASTO'" small title="Buono Pasto"
          >mdi-cash-multiple</v-icon
        >
        <v-icon
          v-if="
            item.custom &&
              item.custom.scalaTaglie &&
              item.custom.scalaTaglie.prodottoMaster
          "
          small
          title="Master scala taglie"
          >mdi-abacus</v-icon
        >
      </template>
      <!--     <template v-slot:[`item.eCommerce.abilita`]="{ item }">
      <v-icon v-if="item.eCommerce && item.eCommerce.abilita" small title="Abilitato per eCommerce">mdi-cart-outline</v-icon>
    </template>
    <template v-slot:[`item.lotti`]="{ item }">
      <v-icon v-if="item.lotti && item.lotti.gestione.abilita" small title="Abilitato per gestione lotti" :color="item.lotti && item.lotti.prodottoBase ? 'red' : ''">mdi-clipboard-text-outline</v-icon>
    </template> -->
      <template v-slot:[`item.prezzo.L1.base`]="{ item }">
        {{ item.prezzo && item.prezzo.L1 && item.prezzo.L1.base | dueDecimali }}
      </template>
      <template v-slot:[`item.prezzo.L2.base`]="{ item }">
        {{ item.prezzo && item.prezzo.L2 && item.prezzo.L2.base | dueDecimali }}
      </template>
      <template v-slot:[`item.magazzino.prezzoAcquisto`]="{ item }">
        {{ item.magazzino && item.magazzino.prezzoAcquisto | dueDecimali }}
      </template>
      <template v-slot:[`item.magazzino.giacenza`]="{ item }">
        <span :title="giacenzaTotale(item)">{{
          calcolaGiacenza(item) | dueDecimali
        }}</span>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="editItem(item)"
          title="Modifica il prodotto"
          >mdi-pencil</v-icon
        >
        <v-icon
          small
          class="mr-2"
          @click="duplicateItem(item)"
          title="Duplica il prodotto"
          >mdi-content-duplicate</v-icon
        >
        <v-icon
          small
          class="mr-2"
          @click="deleteItemWithPassword(item)"
          title="Cancella il prodotto"
          >mdi-delete</v-icon
        >
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="getDataFromApi">Ricarica</v-btn>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="articoliSelected">
          <v-tabs dense v-model="tab[item._id]">
            <v-tab key="storicoVendite" class="articoliSelected"
              >Storico vendite<v-btn icon @click="trigRefreshVendite++"
                ><v-icon>mdi-refresh</v-icon></v-btn
              ></v-tab
            >
            <v-tab key="storicoMovimenti" class="articoliSelected"
              >Storico movimenti<v-btn icon @click="trigRefreshMovimenti++"
                ><v-icon>mdi-refresh</v-icon></v-btn
              ></v-tab
            >
            <v-tab
              key="magazzini"
              v-if="magazziniMultipli"
              class="articoliSelected"
              >Magazzini<v-btn icon @click="trigRefreshMagazzini++"
                ><v-icon>mdi-refresh</v-icon></v-btn
              ></v-tab
            >
            <v-tab 
              key="fornitori" 
              class="articoliSelected"
              >Fornitori<v-btn icon @click="trigRefreshFornitori++"
                ><v-icon>mdi-refresh</v-icon></v-btn
              ></v-tab
            >
            <v-tab
              key="storicoLotti"
              v-if="usaLotti && item.isLotto"
              class="articoliSelected"
              >Storico Lotti<v-btn icon @click="trigRefreshLotti++"
                ><v-icon>mdi-refresh</v-icon></v-btn
              ></v-tab
            >
            <v-tab
              key="distintaBase"
              v-if="usaDistintaBase && item.isBom"
              class="articoliSelected"
              >Distinta Base<v-btn icon @click="trigRefreshDistintaBase++"
                ><v-icon>mdi-refresh</v-icon></v-btn
              ></v-tab
            >
            <v-tab
              key="variazioni"
              v-if="usaVariazioni"
              class="articoliSelected"
              >Variazioni Prodotto<v-btn icon @click="trigRefreshVariazioni++"
                ><v-icon>mdi-refresh</v-icon></v-btn
              ></v-tab
            >
            <v-tab key="allegati" class="articoliSelected">Immagini</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab[item._id]">
            <v-tab-item key="storicoVendite">
              <storico-vendite :item="item" :refresh="trigRefreshVendite" />
            </v-tab-item>
            <v-tab-item key="storicoMovimenti">
              <storico-movimenti :item="item" :refresh="trigRefreshMovimenti" />
            </v-tab-item>
            <v-tab-item key="magazzini" v-if="magazziniMultipli">
              <magazzini :item="item" :refresh="trigRefreshMagazzini" />
            </v-tab-item>
            <v-tab-item key="fornitori">
              <fornitori :item="item" :refresh="trigRefreshFornitori" @aggiorna="onAggiornaFornitori"/>
            </v-tab-item>
            <v-tab-item key="storicoLotti" v-if="usaLotti && item.isLotto">
              <storico-lotti :item="item" :refresh="trigRefreshLotti" />
            </v-tab-item>
            <v-tab-item key="distintaBase" v-if="usaDistintaBase && item.isBom">
              <distinta-base :item="item" :refresh="trigRefreshDistintaBase" />
            </v-tab-item>
            <v-tab-item key="variazioni" v-if="usaVariazioni">
              <variazioni
                :item="item"
                :refresh="trigRefreshVariazioni"
                @aggiornaVariazioni="onAggiornaVariazioni"
                @aggiornaPreparazioni="onAggiornaPreparazioni"
              />
            </v-tab-item>
            <v-tab-item key="allegati">
              <allegati
                :idProdotto="item._id"
                :allegati="item.allegati"
                :triggerUpdate="triggerUpdate"
                @change="onChangeFile"
                @refresh="refreshAllegati(item)"
              />
            </v-tab-item>
          </v-tabs-items>
        </td>
      </template>
    </v-data-table>
    <speed-dial
      :moduloECommerce="moduloECommerce"
      @comando="onSpeedDialogComando"
    />
    <stampa-etichette ref="stampaEtichette" />
  </div>
</template>

<script>
/* eslint-disable */
import { verificaLicenza } from "@/mixins/verificaLicenza.js";
import { dynamicSortMultiple } from "@/components/helpers.js";
import DialogErrore from "@/components/dialogErrore";
import SpeedDial from "./speedDial.vue";
import StampaEtichette from "@/components/etichette/stampaEtichette";
import Filtri from "./filtri";
import StoricoVendite from "./elementi/storicoVendite";
import StoricoMovimenti from "./elementi/storicoMovimenti";
import StoricoLotti from "./elementi/storicoLotti";
import DistintaBase from "./elementi/distinta";
import Magazzini from "./elementi/magazzini";
import Fornitori from "./elementi/fornitori";
import Variazioni from "./elementi/variazioni";
import prodotti from "@/services/prodottiService.js";
import configurazioni from "@/services/configurazioniService.js";
import Allegati from "./elementi/allegati";

export default {
  components: {
    DialogErrore,
    Filtri,
    SpeedDial,
    StampaEtichette,
    StoricoVendite,
    StoricoMovimenti,
    StoricoLotti,
    DistintaBase,
    Magazzini,
    Fornitori,
    Variazioni,
    Allegati,
  },
  mixins: [verificaLicenza],
  props: {
    articolo: { type: String, default: "" },
  },
  data() {
    return {
      totaleArticoli: 0,
      articoli: [],
      selected: [],
      loading: true,
      options: { itemsPerPage: 50 },
      headersDefault: [
        // Caricato se non ci sono impostazioni diverse nel DB
        { text: "Codice", value: "codice", align: "start" },
        { text: "Descrizione", value: "descrizione" },
        { text: "Taglia", value: "varianti.variante1.descrizione" },
        { text: "Colore", value: "varianti.variante2.descrizione" },
        { text: "Marchio", value: "marchio" },
        { text: "Listino €", value: "prezzo.L2.base", align: "end" },
        {
          text: "Prezzo €",
          name: "prezzo",
          value: "prezzo.L1.base",
          align: "end",
        },
        { text: "Acquisto €", value: "magazzino.prezzoAcquisto", align: "end" },
        { text: "Giacenza", value: "magazzino.giacenza", align: "end" },
        {
          text: "Prod/Rep",
          value: "tipoItem",
          align: " d-none d-xl-table-cell",
        },
        { text: "Bene", value: "tipoBene", align: " d-none d-xl-table-cell" },
        { text: "Actions", value: "actions", sortable: false },
        { text: "", value: "data-table-expand" },
      ],
      headersBase: [
        { text: "Actions", value: "actions", sortable: false },
        { text: "", value: "data-table-expand" },
      ],
      /*         headersECommerce: [
                  { text: '', value: 'eCommerce.abilita' }
                ],
                headersLotti: [
                  { text: '', value: 'lotti' }
                ], */
      headersSpeciali: [{ text: "", value: "speciali", width: 80 }],
      headersBO: [],
      dialogErrore: false,
      dialogDelete: false,
      dialogECommerce: false,
      editedIndex: -1,
      editedItem: null,
      defaultItem: null,
      filtri: {
        tipoItem: "PRODOTTO",
        testo: "",
        marchio: [],
        variante1: [],
        variante2: [],
        stagione: [],
        categoria1: [],
        categoria2: [],
      },
      expanded: [],
      singleExpand: false,
      tab: {},
      trigRefreshVendite: 0,
      trigRefreshMovimenti: 0,
      trigRefreshLotti: 0,
      trigRefreshDistintaBase: 0,
      trigRefreshVariazioni: 0,
      trigRefreshMagazzini: 0,
      trigRefreshFornitori: 0,
      triggerUpdate: 0,
      usaTagliaColore: false,
      usaLotti: false,
      usaDistintaBase: false,
      usaVariazioni: false,
      codiceCancellazione: "",
      moduloECommerce: false,
      moduloLotti: false,
      cancellazioneMultipla: false,
      forzaRefreshCache: false,
      disableButtonConfirmCancellation: false,
    };
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuovo Articolo" : "Modifica Articolo";
    },
    productSaved() {
      return this.$store.getters["prodotti/saved"];
    },
    refreshList() {
      return this.$store.getters["prodotti/refresh"];
    },
    articoliSorted() {
      const els = this.articoli;
      if (this.options.sortBy && this.options.sortBy.length > 0) {
        return els;
      } else {
        const elSorted = _.sortBy(els, [
          "descrizione",
          "varianti.variante2.descrizione",
          "varianti.variante1.descrizione",
        ]);
        return elSorted;
      }
      /* const elSorted = els.length > 0 ? els.sort(dynamicSortMultiple('descrizione', 'varianti.variante2.descrizione', 'varianti.variante1.descrizione')) : []
      return elSorted */
    },
    headers() {
      /*         let ecommerce = this.moduloECommerce ? this.headersECommerce : []
                let lotti = this.moduloLotti ? this.headersLotti : [] */
      // let base = this.moduloECommerce || this.moduloLotti ? this.headersSpeciali : []
      let base = this.headersSpeciali;
      return base.concat(this.headersBO).concat(this.headersBase);
    },
    magazziniMultipli() {
      return this.$store.getters["magazzini/magazziniMultipli"];
    },
    magazzinoSelezionato() {
      // Si può usare il getter perchè la chiamata asincrona è stata fatta dalla root
      return this.$store.getters["magazzini/codiceMagazzino"];
    },
  },
  watch: {
    options: {
      async handler() {
        await this.getDataFromApi();
      },
      deep: true,
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    async productSaved(value) {
      if (value) {
        await this.save();
      }
    },
    async refreshList(value) {
      if (value) {
        await this.getDataFromApi();
        this.$store.commit("prodotti/CLEAR_REFRESH");
      }
    },
    async magazzinoSelezionato() {
      console.log("Il magazzino è cambiato");
      await this.onRicerca();
    },
  },
  async created() {
    this.defaultItem = await prodotti.getModello();
    const backoffice = await configurazioni.getConfigurazione(
      "backoffice",
      "impostazioni"
    );
    this.headersBO = _.get(
      backoffice,
      "prodotti.griglia.headers",
      this.headersDefault
    );
    this.usaTagliaColore = backoffice.usaTagliaColore || false;
    this.usaLotti = backoffice.usaLotti || false;
    this.usaDistintaBase = backoffice.usaDistintaBase || false;
    this.usaVariazioni = backoffice.usaVariazioni || false;
    this.codiceCancellazione = backoffice.codiceCancellazione || "0000";

    this.moduloECommerce =
      _.get(backoffice, "eCommerce.abilitato", false) || false; // TODO: Impostare se licenza abilitata
    this.moduloLotti = _.get(backoffice, "usaLotti", false) || false; // TODO: Impostare se licenza abilitata
  },
  async mounted() {
    await this.gestioneToken();
    if (this.articolo) {
      this.filtri = {
        codice: this.articolo,
      };
      await this.getDataFromApi();
      // this.onRicerca({ codice: this.articolo })
    }
    // await this.getDataFromApi()
  },
  methods: {
    async onChangeFile({ idProdotto, tipo, payload }) {
      switch (tipo) {
        case "addFile":
        case "updateFile":
          const operations = payload.filter(
            (a) => "tipo" in a && a.tipo === "totem"
          );
          payload = payload.filter((a) => !("tipo" in a) || a.tipo !== "totem");
          await prodotti.aggiornaAllegati(idProdotto, payload);
          console.log(payload);
          for (const operation of operations) {
            console.log("operation", operation);
            await configurazioni.registraTodo(operation);
          }
        case "deleteFile":
          await prodotti.eliminaAllegato(idProdotto, payload);
          break;
        default:
          break;
      }
      this.forzaRefreshCache = true;
      await this.getDataFromApi();
      this.triggerUpdate++;
    },
    async refreshAllegati(item) {
      const filtri = { id: item._id };
      const data = await prodotti.getFilteredProducts(
        filtri,
        this.options,
        null,
        true
      );
      const articoli =
        data && data.total_rows > 0 ? data.rows.map((x) => x.doc) : [];
      item.allegati = articoli[0].allegati || [];
    },
    async onAggiornaVariazioni(item) {
      const id = item._id;
      let prodotto = await prodotti.getProdotto(id);
      if (prodotto) {
        prodotto.variazioni = item.variazioni;
        await prodotti.aggiornaProdotto(prodotto);
        this.trigRefreshVariazioni++;
      }
    },
    async onAggiornaPreparazioni(item) {
      const id = item._id;
      let prodotto = await prodotti.getProdotto(id);
      if (prodotto) {
        prodotto.preparazioni = item.preparazioni;
        await prodotti.aggiornaProdotto(prodotto);
        this.trigRefreshVariazioni++;
      }
    },
    async onAggiornaFornitori(item) {
      const id = item._id
      let prodotto = await prodotti.getProdotto(id)
      if (prodotto) {          
        prodotto.fornitori = item.fornitori
        await prodotti.aggiornaProdotto(prodotto)
        await prodotti.clearCache()
        this.trigRefreshFornitori++
      }
    },
    apriCommerce(item) {
      if (item.eCommerce && item.eCommerce.url) {
        window.open(item.eCommerce.url);
      }
    },
    calcolaGiacenza(item) {
      const giacenza = _.get(item, "magazzino.giacenza", 0);
      if (!this.magazziniMultipli) {
        return giacenza;
      } else {
        const giacenzaParziale = _.get(item, "magazzino.giacenzaParziale", 0);
        if (
          typeof giacenzaParziale === "object" &&
          !_.isEmpty(giacenzaParziale)
        ) {
          const gg = giacenzaParziale[this.magazzinoSelezionato] || {};
          return gg.giacenza || 0;
        } else {
          return this.magazzinoSelezionato === "mag01" ? giacenza : 0;
        }
      }
    },
    giacenzaTotale(item) {
      try {
        return `Giacenza totale: ${(item.magazzino &&
          item.magazzino.giacenza) ||
          0}`;
      } catch (err) {
        console.log("Prodotto in errore:", item._id);
      }
    },
    titleLotti(item) {
      if (item.lotti && item.lotti.gestione) {
        return (
          "Abilitato per gestione lotti" +
          (item.lotti && item.lotti.prodottoBase ? " - Prodotto Base" : "")
        );
      } else {
        return item.lotti && item.lotti.prodottoBase ? "Prodotto Base" : "";
      }
    },
    coloreLotti(item) {
      return item.lotti && item.lotti.prodottoBase ? "red" : "";
    },
    allegatiEcommerce(item) {
      return item.allegati &&
        item.allegati.filter((x) =>
          ["eCommerce", "tutto"].includes(_.get(x, "description.codice"))
        ).length > 0
        ? "blue"
        : "";
    },
    titleBom(item) {
      return "Abilitato per gestione distinta base";
    },
    coloreBom(item) {
      // TODO: Gestire se necessario
      return "";
    },
    async onRicerca(filtri) {
      if (filtri) this.filtri = filtri;
      this.filtri.tipoItem = "PRODOTTO"; // verificare come e se mettere
      this.filtri.nomeMag = this.magazzinoSelezionato;
      await this.getDataFromApi();
    },
    async getDataFromApi() {
      try {
        // console.log('getDataFromApi')
        this.loading = true;
        // console.log(this.options)
        const data = await prodotti.getFilteredProducts(
          this.filtri,
          this.options,
          null,
          this.forzaRefreshCache
        );
        const articoli =
          data && data.total_rows > 0 ? data.rows.map((x) => x.doc) : [];
        this.articoli = articoli.map((el) => {
          el.allegati = el.allegati || [];
          return { ...el };
        });

        this.totaleArticoli = data.total_rows;
      } catch (err) {
        this.articoli = [];
        this.totaleArticoli = 0;
      } finally {
        this.loading = false;
      }
    },
    onNuovoArticolo() {
      this.editedIndex = -1;
      // this.editedItem = Object.assign({}, this.defaultItem)
      this.editedItem = Object.assign(
        {},
        JSON.parse(JSON.stringify(this.defaultItem))
      );
      this.$store.commit("prodotti/SET_PRODOTTO", this.editedItem);
      this.$store.commit("SET_RIGHT_DRAWER_READ_ONLY", false);
      this.$store.commit("SET_RIGHT_DRAWER", true);
    },
    editItem(item) {
      this.editedIndex = this.articoli.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$store.commit("prodotti/SET_PRODOTTO", this.editedItem);
      this.$store.commit("SET_RIGHT_DRAWER_READ_ONLY", false);
      this.$store.commit("SET_RIGHT_DRAWER", true);
    },
    duplicateItem(item) {
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, item);
      this.editedItem._id = "";
      this.editedItem.barcode = [];
      this.editedItem.ricercaBarcode = "";
      this.editItem.magazzino = {};
      this.editItem.ultimoAcquisto = {};
      delete this.editedItem._rev;
      this.$store.commit("prodotti/SET_PRODOTTO", this.editedItem);
      this.$store.commit("SET_RIGHT_DRAWER_READ_ONLY", false);
      this.$store.commit("SET_RIGHT_DRAWER", true);
    },
    deleteItemWithPassword(item) {
      if (
        prompt("inserire codice per cancellazione") === this.codiceCancellazione
      ) {
        this.deleteItem(item);
      }
    },
    deleteItem(item) {
      this.editedIndex = this.articoli.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    async deleteItemConfirm() {
      this.disableButtonConfirmCancellation = true;
      if (this.cancellazioneMultipla) {
        let erroreCancellazione = false;
        for (let p of this.selected) {
          const idx = this.articoli.findIndex((x) => x._id === p._id);
          this.articoli.splice(idx, 1);
          if (!(await prodotti.cancellaProdotto(p))) {
            erroreCancellazione = true;
          }
        }
        this.dialogErrore = erroreCancellazione;
        this.cancellazioneMultipla = false;
      } else {
        this.articoli.splice(this.editedIndex, 1);
        // TODO: ATTENZIONE VA VERIFICATO CHE NON ABBIA STORIA
        if (!(await prodotti.cancellaProdotto(this.editedItem))) {
          this.dialogErrore = true;
        }
      }
      await prodotti.clearCache();
      this.closeDelete();
    },

    close() {
      this.$store.commit("SET_RIGHT_DRAWER", false);
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.disableButtonConfirmCancellation = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      this.$store.commit("prodotti/CLEAR_PRODOTTO_SAVED");
      this.editedItem = this.$store.getters["prodotti/prodotto"];
      if (this.editedIndex > -1) {
        Object.assign(this.articoli[this.editedIndex], this.editedItem);
        if (!(await prodotti.aggiornaProdotto(this.editedItem))) {
          this.dialogErrore = true;
          return;
        }
      } else {
        this.articoli.push(this.editedItem);
        const newPr = await prodotti.creaProdotto(this.editedItem);
        if (!newPr) {
          this.dialogErrore = true;
          return;
        }
        this.$store.commit("prodotti/SET_PRODOTTO", newPr);
      }
      this.close();
      // va fatto il refresh della lista per prendere gli aggiornamenti
      await this.getDataFromApi();
    },
    erroreConfirm() {
      this.dialogErrore = false;
    },
    clickRow(item, options) {},
    dblclickRow(event, options) {
      const item = options.item;
      this.editedIndex = this.articoli.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$store.commit("prodotti/SET_PRODOTTO", this.editedItem);
      this.$store.commit("SET_RIGHT_DRAWER_READ_ONLY", true);
      this.$store.commit("SET_RIGHT_DRAWER", true);
    },
    onSpeedDialogComando(comando, payload) {
      switch (comando) {
        case "stampa-etichette":
          this.$refs.stampaEtichette.stampaEtichette(
            this.elencoEtichette(),
            "articoli"
          );
          this.annullaSelezione();
          break;
        case "abilita-ecommerce":
          this.dialogECommerce = true;
          break;
        case "elimina-articoli":
          if (
            prompt("inserire codice per cancellazione") ===
            this.codiceCancellazione
          ) {
            this.cancellazioneMultipla = true;
            this.dialogDelete = true;
          }
        default:
          break;
      }
    },
    elencoEtichette() {
      const etichette = this.selected.map((el) => {
        return {
          id: el._id,
          idpr: el._id,
          quantita: 1,
        };
      });
      return etichette;
    },
    async eCommerceConfirm() {
      const ids = this.selected.map((el) => el._id);
      await prodotti.abilitaECommerceByIds(ids, true);
      this.dialogECommerce = false;
      this.annullaSelezione();
      await this.getDataFromApi();
    },
    /*       elencoEtichette() {
              const etichette = this.selected.map(el => {
                return {
                  codice: el.codice,
                  descrizione: el.descrizione,
                  taglia: el.varianti && el.varianti.variante1.codice,
                  colore: el.varianti && el.varianti.variante2.codice,
                  prezzo: el.prezzo && el.prezzo.L1 && el.prezzo.L1.base,
                  acquisto: el.magazzino.prezzoAcquisto,
                  barcode: el.ricercaBarcode,
                  prezzo2: el.prezzo && el.prezzo.L2 && el.prezzo.L2.base,
                  quantita: 1 // verificare
                }
              })
              return etichette
            }, */
    annullaSelezione() {
      while (this.selected.length > 0) {
        this.selected.pop();
      }
    },
  },
};
</script>

<style lang="scss">
tr.v-data-table__expanded__content {
  box-shadow: none !important;
}

td.articoliSelected {
  border-style: solid !important;
  border-width: 2px !important;
  border-color: #1976d2 !important;
}
</style>
